/* eslint-disable no-fallthrough */
/* https://jquense.github.io/react-widgets/ */
/* https://www.npmjs.com/package/react-spinners */

import React, { Component } from 'react';

//import "react-widgets/styles.css";
import '../../index.css'
//import "react-widgets/scss/styles.scss";

//import NumberPicker from "react-widgets/NumberPicker";
import Combobox from "react-widgets/Combobox";
import DropdownList from "react-widgets/DropdownList";
import DatePicker from "react-widgets/DatePicker";
import Listbox from "react-widgets/Listbox";
import ClipLoader from "react-spinners/ClipLoader";
import RadioButtons from "./RadioButtons";

import { showPopopMessage } from "../../Components/PopupMessage/Toastify.js";
import { TYPE_MESSAGE_EXCEEDS_LENGTH, TYPE_MESSAGE_WRONG_CASE, TYPE_MESSAGE_UNAVAILABLE_SYMBOL } from "../../Components/PopupMessage/Toastify.js";
import { message } from '../../../node_modules/react-widgets/esm/PropTypes';
import { requestBase, apiroot } from "./Fetch-helpers";

import { InputNumber } from "primereact/inputnumber"
import "primereact/resources/themes/mira/theme.css"

export default class CdsFeatureItem extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.postData.bind(this);
        this.handleKeyDownText = this.handleKeyDownText.bind(this);
        this.handleKeyDownNumeric = this.handleKeyDownNumeric.bind(this);

        this.state = {
            waiting: false, posting: false, //value: this.props.feature.currentValue,
            timerOn: false, timerDuration: 0, timerTime: 0,// valuefortimer: null,
            //inputNumber: null,
        };

    }

    /**
     * Таймер
     * 
     */

    startTimer = (msDuration) => {
        this.setState({
            timerOn: true,
            timerTime: 0, //this.state.timerTime,
            timerDuration: msDuration //this.state.timerTime
        });
        this.timer = setInterval(() => {
            const newTime = this.state.timerTime + 10;
            if (newTime < this.state.timerDuration) {
                this.setState({
                    timerTime: newTime
                });
            } else {
                this.stopTimer();
                //alert("Countdown ended");
                //let val = this.validate(this.state.valuefortimer);
                this.setState({ waiting: true });

                this.postData();
            }
        }, 10);
    };
    stopTimer = () => {
        clearInterval(this.timer);
        this.setState({ timerOn: false, timerTime: 0 });
    };
    resetTimer = () => {
        if (this.state.timerOn === true) {
            this.setState({
                timerTime: 0 //this.state.timerStart
            });
        }
    };


    async postDataAsync(feature) {

        console.log("Выполняем PATCH для CDS...");
        console.log("Значение (" + feature.description + "): " + feature.currentValue);

        try {
            let response = await fetch(apiroot + "CDS"  /*feature.id*/,
                Object.assign({}, requestBase, {
                    method: "PATCH",
                    //credentials: 'include',
                    headers: {
                        'Accept': 'application/json', //, text/plain
                        'Content-Type': 'application/json'//;charset=UTF-8
                    },
                    body: JSON.stringify(feature)
                }));

            if (!response.ok) {

                switch (response.status) {
                    case 599:

                        console.log("Повторно Get Configuration...");
                        await this.props.updateConfiguration(undefined, true);

                        console.log("Повторно PATCH...");
                        response = await fetch(apiroot + "CDS" /*+ (params.cfgid == null ? "" : params.cfgid)*/,
                            Object.assign({}, requestBase, {
                                method: "PATCH",
                                //credentials: 'include',
                                headers: {
                                    'Accept': 'application/json', //, text/plain
                                    'Content-Type': 'application/json'//;charset=UTF-8
                                },
                                body: JSON.stringify(feature)
                            }));

                        break;
                    default:
                        const data = await response.json();
                        console.log(JSON.stringify(data));
                        //alert("Какая-то фигня! Смотри консоль...\nЕще можно нажать F5");
                        //this.setState({ posting: false });
                        return;
                }

                if (!response.ok) {
                    const data = await response.json();
                    console.log(JSON.stringify(data));
                    //this.setState({ posting: false });
                    return;
                }
            }

            console.log("PATCH отработал нормально");

            const data = await response.json();
            this.props.handleUpdate(data, feature.id);
        }
        catch (err) {
            this.props.showError(err);
        }

    }

    async postDataAsyncTry(feature) {
        try {
            this.props.handleLock(true);
            await this.postDataAsync(feature);
        }
        finally {
            this.props.handleLock(false);
            this.setState({ posting: false });
        }
    }

    postData = () => {
        const feature = this.props.feature;

        feature.configurationId = this.props.configurationId;
        feature.CDSId = this.props.cdsId;
        //feature.currentValue = this.state.value;

        this.setState({ waiting: false, posting: true });
        this.postDataAsyncTry(feature);
    }

    validate = (value) => {
        const feature = this.props.feature;
        switch (feature.type) {
            case "numericUpDown":
                feature.currentValue = value === null ? '' : String(value);
                break;
            //feature.currentValue = Number(value) == NaN ? 0 : Number(value);
            case "textBox":
                feature.currentValue = String(value);
                break;
            case "comboBox":
                if (feature.values.filter((f) => f.id == value.id)[0].enable) {
                    if (feature.values.filter((f) => f.selected == true).length > 0) {
                        let prev_v = feature.values.filter((f) => f.selected == true);
                        if (prev_v.length > 0)
                            prev_v[0].selected = false;
                    }
                    feature.values.filter((f) => f.id == value.id)[0].selected = true;
                } else {
                    throw new Error('not valid');
                }
                break;
            case "dateTime":
                if (value != null && value != '') {
                    var dd = String(value.getDate()).padStart(2, '0');
                    var mm = String(value.getMonth() + 1).padStart(2, '0'); //January is 0!
                    var yyyy = value.getFullYear();
                    feature.currentValue = dd + "." + mm + "." + yyyy;
                } else {
                    feature.currentValue = null;
                }
                break;
            case "radio":
                if (feature.values.filter((f) => f.selected == true).length > 0) {
                    let prev_v = feature.values.filter((f) => f.selected == true);
                    if (prev_v.length > 0)
                        prev_v[0].selected = false;
                }
                feature.values.filter((f) => f.id == value.id)[0].selected = true;
                feature.currentValue = value.description;
                break;
            default:
                feature.currentValue = String(value);
        }

        return feature.currentValue;
    }

    changingValue = (value) => {

        try {
            let val = this.validate(value);
            //this.setState({ value: val, waiting: true });
            //this.setState({ valuefortimer: value });
            //this.props.feature.currentValue = value;

            if (!this.state.timerOn) {
                this.startTimer(1000);
            } else {
                this.resetTimer();
            }
        } catch { }
    }

    leavingControl = (value) => {

        //this.setState({ value: this.validate(value), waiting: true });

        if (this.state.timerOn) {
            this.stopTimer();
            this.postData();
        }
    }

    //leavingControlNumeric = () => {
        
    //    if (!this.state.timerOn) {
            
    //        const feature = this.props.feature;
    //        this.state.inputNumber.value = feature.currentValue;
    //        //this.state.inputNumber.set'aria-valuenow'

    //        this.stopTimer();
    //        //this.postData();
    //    }
    //}

    handleKeyDownNumeric(event) {
        //if (!this.state.inputNumber)
        //    this.setState({ inputNumber: event.target });

        if (event.key.length == 1 && "0123456789,.-".indexOf(event.key) === -1) {
            event.preventDefault();
            showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return;
        }

        //if (event.key.length == 1 && ",.".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    if (currentValue.indexOf('.') != -1 || currentValue.indexOf(',') != -1) {
        //        event.preventDefault();
        //        showPopopMessage("Необходимо ввести число!", TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
        //        return;
        //    }
        //}

        //if (event.key.length == 1 && "-".indexOf(event.key) != -1) {
        //    const currentValue = event.target.defaultValue;
        //    // если '-' уже есть, и пытаются еще один ввести, то не даем
        //    if (currentValue.indexOf('-') != -1) {
        //        event.preventDefault();
        //        return;
        //    }
        //    // если пытаются ввести '-' не в начале числа, то не даем
        //    if (currentValue.length > 1 && event.target.selectionStart > 0) {
        //        event.preventDefault();
        //        return;
        //    }
        //}
    }

    handleKeyDownText(event) {
        const feature = this.props.feature;
        const currentValue = event.target.defaultValue; /*tag.lines.filter((l) => l.lineId == currentLineId)[0].value;*/
        const control = event.target;

        if (event.key.length == 1) {
            if (feature.characterCount > 0 && currentValue.length >= feature.characterCount) {
                if (control.selectionEnd - control.selectionStart == 0) {
                    event.preventDefault();
                    showPopopMessage("Максимум символов: " + feature.characterCount, TYPE_MESSAGE_EXCEEDS_LENGTH);
                    return;
                }
            }
        }

        /*if (tag.case == 1) {
            if (event.key == event.key.toUpperCase() && event.key != event.key.toLowerCase()) {
                event.preventDefault();
                alert("Только нижний регистр!");
                return;
            }
        }
        if (tag.case == 2) {
            if (event.key == event.key.toLowerCase() && event.key != event.key.toUpperCase()) {
                event.preventDefault();
                alert("Только верхний регистр!");
                return;
            }
        }*/
        if (event.key.length == 1 && feature.allowedCharacters != undefined && feature.allowedCharacters != '' && feature.allowedCharacters.indexOf(event.key) === -1) {
            event.preventDefault();
            showPopopMessage(<div>Вы ввели недопустимый символ!<p>Разрешенный набор: {`${feature.allowedCharacters}`}</p></div>, TYPE_MESSAGE_UNAVAILABLE_SYMBOL);
            return;
        }
        //this.setState({ value: event.key.toUpperCase() });
        //this.setState({ key1: String(event.key) });
    }

    render() {
        const feature = this.props.feature;
        const autoSize = this.props.autoSize;
        const enable = this.props.extDisable ? false : feature.enable;

        let titleValue = "";
        let titleStatus = "";

        const colorLoader = "white";
        let colorStatusClass = "";
        if (this.state.waiting) {
            colorStatusClass = "yellowlightOptFea";
            titleStatus = "";
        }
        if (this.state.posting) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр в процессе сохранения...";
        }
        if (!enable) {
            colorStatusClass = "greyOptFea";
            titleStatus = "Параметр недоступен для редактирования";
        } else {
            if (colorStatusClass == "") {
                colorStatusClass = feature.validate === true ? "grnOptFea" : "redOptFea";
                titleStatus = feature.validate === true ? "Параметр введен корректно" : "Значение параметра введено неверно";
            }
        }

        // eslint-disable-next-line default-case
        switch (feature.type) {
            case "label":
                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <label className={'FeatureLabel'}>{feature.currentValue}</label>
                    </div>
                );
            case "numericUpDown":

                const _min = !isNaN(parseFloat(feature.min)) ? parseFloat(feature.min) : null;
                const _max = !isNaN(parseFloat(feature.max)) ? parseFloat(feature.max) : null;
                titleValue = "Диапазон допустимых значений: от " + _min + " до " + _max +
                    (this.props.difference != undefined && this.props.difference != '' ? "\n" + "Должен отличаться от параметра '" + this.props.differenceDescription + "' не меньше, чем на " + this.props.difference : "");

                let dotind = ('' + feature.step).indexOf('.');
                let precision = dotind > 0 ? ('' + feature.step).length - dotind - 1 : 0;

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment" title={titleValue} >
                                        {/* {this.state.timerTime == 0 ? "" : 100 * Math.floor(1 + this.state.timerTime / 100) + "мс"}*/}
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <InputNumber
                                                showButtons
                                                locale="ru-RU"
                                                value={typeof feature.currentValue == "string" ? feature.currentValue.replace(',', '.') : feature.currentValue}
                                                onChange={e => this.changingValue(e.value)}
                                                minFractionDigits={precision}
                                                disabled={!enable}
                                                max={_max}
                                                //min={_min}                                                
                                                step={feature.step}
                                                onKeyDown={this.handleKeyDownNumeric}      
                                                tooltip={`min:${_min} max:${_max} step:${feature.step}`}
                                                tooltipOptions={{ position: 'bottom', showDelay: 300, hideDelay: 300 }}
                                            />

                                            {/*<NumberPicker*/}
                                            {/*    //{...(this.state.waiting && { readOnly: true })}*/}
                                            {/*    //defaultValue={Number(this.props.feature.currentValue)}*/}
                                            {/*    value={typeof feature.currentValue == "string" ? Number(feature.currentValue.toString().replace(',', '.')) : feature.currentValue}*/}
                                            {/*    //value={typeof this.props.feature.currentValue == "string" ? Number(this.props.feature.currentValue.toString().replace(',', '.')) : this.props.feature.currentValue} //{Number(this.state.value)}*/}
                                            {/*    max={feature.max}*/}
                                            {/*    min={feature.min}*/}
                                            {/*    step={feature.step}*/}
                                            {/*    precision={precision}*/}
                                            {/*    messages={{*/}
                                            {/*        increment: `Увеличить на ${feature.step}`,*/}
                                            {/*        decrement: `Уменьшить на ${feature.step}`,*/}
                                            {/*    }}*/}
                                            {/*    onChange={value => this.changingValue(value)}*/}
                                            {/*    //onBlur={value => this.leavingControlNumeric()}*/}
                                            {/*    readOnly={!enable}*/}
                                            {/*    onKeyDown={this.handleKeyDownNumeric}*/}
                                                
                                            {/*/>*/}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "comboBox":
                var cb_values = feature.values;
                try {
                    cb_values.sort((a, b) => Number(a.sequence.toString().replace(',', '.')) > Number(b.sequence.toString().replace(',', '.')) ? 1 : -1);
                }
                catch (err) {
                    //???!!!зацикливает вывод сообщение-рендер
                    //this.props.showError({ name: "Ошибка сортировки значений", message: "Ошибка значения sequence", stack : err });
                }

                cb_values = cb_values.filter((f) => f.visible == true);
                const maxLength = 8 + cb_values.reduce((acc, item) => Math.max(acc, item.description.length), 0);
                const cb_values_selected = cb_values.filter((f) => f.selected == true);
                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment" >
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent /*!!!сжимает поле ввода ${(autoSize === 1 ? "autosizeByContent" : "")}*/ ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`} width="100px"
                                            style={autoSize === 1 ? { width: `${maxLength}ex` } : {}}
                                        >
                                            <DropdownList
                                                filter={false}
                                                /*hideEmptyPopup*/
                                                data={cb_values}
                                                dataKey='id'
                                                textField='description'
                                                value={cb_values_selected.length > 0 ? cb_values_selected[0].id : ''}
                                                onChange={value => this.changingValue(value)}
                                                disabled={!enable}
                                                itemDisabled={item => !item.enable}
                                                renderListItem={({ item }) => (
                                                    <div className={`DropdownItem ${(item.enable ? "" : "Dropdowndisable")}`}>
                                                        <span >
                                                            {item.description}
                                                        </span>
                                                    </div>
                                                )}

                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "textBox":

                if (feature.characterCount != undefined && feature.characterCount != '') {
                    titleValue = "Маскимальное количество символов: " + feature.characterCount;
                }

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment" title={titleValue}>
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <Combobox
                                                hideCaret
                                                hideEmptyPopup
                                                value={feature.currentValue}//{this.props.feature.currentValue} //{this.state.value}
                                                onKeyDown={this.handleKeyDownText}
                                                onChange={value => this.changingValue(value)}
                                                onBlur={value => this.leavingControl()}
                                                readOnly={!enable}
                                                placeholder={enable ? "Введите текстовое сообщение" : ""}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "dateTime":
                let dtvalue = feature.currentValue; //this.props.feature.currentValue; //feature.currentValue;
                if (dtvalue == '') dtvalue = null;
                if (dtvalue != null) {
                    var parts = dtvalue.split('.');
                    if (parts.length === 3) {
                        dtvalue = new Date(parts[2], parts[1] - 1, parts[0]);
                    }
                } else {
                    //dtvalue = new Date();
                }

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment">
                                        {feature.description}
                                        <div className={`cdsFeatureItemHeaderContent ${(autoSize === 1 ? "autosizeByContent" : "")} ${(feature.validate === undefined ? "rw-widget-unvalid" : "")}`}>
                                            <DatePicker
                                                //placeholder="ДД.ММ.ГГГГ"
                                                value={dtvalue}
                                                valueEditFormat={{ dateStyle: "short" }}
                                                valueDisplayFormat={{ dateStyle: "medium" }}
                                                messages={{
                                                    moveToday: "Сегодня",
                                                    moveBack: "Назад",
                                                    moveForward: "Вперед",
                                                    dateButton: "Выбор даты",
                                                }}
                                                onChange={value => this.changingValue(value)}
                                                //onBlur={value => this.leavingControl()}
                                                readOnly={!enable}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
            case "radio":
                let radioValues = feature.values;

                return (
                    <div class="cdsFeatureItemHeaderComment">
                        <table>
                            <tbody>
                                <tr>
                                    <td title={titleStatus} className={`cdsFeatureItemHeaderComment ${colorStatusClass}`} >
                                        <div id={`${colorStatusClass}`} style={this.state.posting == true ? { display: "block" } : { display: "none" }}>
                                            <ClipLoader id={`${colorStatusClass}`}
                                                color={colorLoader}
                                                loading={this.state.posting}
                                                //cssOverride={override}
                                                size="12px"
                                                speedMultiplier="0.7"
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                    </td>
                                    <td class="cdsFeatureItemHeaderComment">
                                        {feature.description}
                                        <div class={`cdsFeatureItemHeaderContent ${autoSize === 1 ? "autosizeByContent" : ""}`}>
                                            <RadioButtons
                                                data={radioValues}
                                                onChange={value => this.changingValue(value)}
                                                readOnly={!enable}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                );
        }
    }
}